<template>
    <Teleport to="body">
        <Transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="opacity-0"
            leave-active-class="transition ease-in duration-150"
            leave-to-class="opacity-0"
        >
            <div v-if="show" class="fixed inset-0 z-40 bg-gray-900/50" @click="$emit('close')" />
        </Transition>

        <Transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="translate-y-8 opacity-0"
            leave-active-class="transition ease-in duration-150"
            leave-to-class="translate-y-8 opacity-0"
        >
            <div
                v-if="show"
                class="fixed inset-x-0 bottom-0 z-50 bg-white rounded-t-2xl px-4 pt-2 pb-4"
                role="dialog"
                aria-modal="true"
                aria-labelledby="sign-in-prompt-title"
            >
                <div class="w-9 h-1 mx-auto mb-3 rounded-full bg-gray-200" />

                <SignInPrompt
                    :space="space"
                    :current-day="currentDay"
                    :start-time="startTime"
                    @close="$emit('close')"
                />
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
    import { onBeforeUnmount, onMounted } from "vue";
    import SignInPrompt from "./SignInPrompt.vue";

    const props = defineProps({
        show: Boolean,
        space: Object,
        currentDay: Object,
        startTime: Number,
    });

    const emits = defineEmits(["close"]);

    // A sheet with aria-modal has to answer Escape, or keyboard users are stuck in it.
    const closeOnEscape = (event) => {
        if (event.key === "Escape" && props.show) {
            emits("close");
        }
    };

    onMounted(() => window.addEventListener("keydown", closeOnEscape));

    onBeforeUnmount(() => window.removeEventListener("keydown", closeOnEscape));
</script>
